import React from 'react';
import ReactDOM from 'react-dom';
import { fetchData } from '../../../helpers/base_data_fetcher';
import MessagingProfileForm from '../../../components/profiles/updateProfileModal/MessagingProfileForm';

export default function renderMessagingProfile(isMobile = false) {
  // Needed for upload photo chunking
  const profileFormMount = document.getElementById('profileForm');
  const { uploadSession, usertype } = profileFormMount.dataset;

  Promise.all([
    fetchData('customer'),
    fetchData('site'),
    fetchData('page'),
  ]).then(([customer, site, page]) => {
    let seeker = false;
    let offerer = false;

    if (usertype) {
      const userTypeArray = usertype.split(',');
      seeker =
        userTypeArray.includes('lookingforashare') ||
        userTypeArray.includes('makeashare');
      offerer = userTypeArray.includes('haveashare');
    }

    ReactDOM.render(
      <MessagingProfileForm
        uuid={customer.uuid}
        subDir={site.sub_dir}
        country={site.country}
        isMobile={isMobile}
        uploadSession={uploadSession}
        seeker={seeker}
        offerer={offerer}
        localisations={page.profile}
      />,
      profileFormMount,
    );
  });
}
